import React, { useEffect, useState } from "react";
import "./FlightLoader.scss";
import { Col, Row } from "antd";
import { img_Loader } from "../utils/ImagePath";
import FirecrackerEffect from "../components/Offers/FirecrackerEffect";


const FlightLoader = () => {
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        requestAnimationFrame(() => {
            setShowLoader(true);
        });
    }, []);

    if (!showLoader) return null;

    return (
        <div className="page-loader">
            {/* <FirecrackerEffect /> */}
            <div className="container">
                <Row gutter={20}>
                    <Col xs={24} className="text-center">
                        <div className="d-flex align-items-center justify-content-center w-100 text-center position-relative">
                            <img
                                src={img_Loader}
                                loading="lazy"
                                width={140}
                                height={177}
                                className="mb-3"
                                alt=""
                                role="presentation"
                                aria-hidden="true"
                                decoding="async"
                            />
                            <div className="spinner" role="presentation" aria-hidden="true" />

                        </div>
                        <h2 className="loading">Please wait <span className="loader"></span></h2>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default FlightLoader;
